import { BitString } from "@peculiar/asn1-schema";
export var PKIFailureInfoFlags;
(function (PKIFailureInfoFlags) {
    PKIFailureInfoFlags[PKIFailureInfoFlags["badAlg"] = 1] = "badAlg";
    PKIFailureInfoFlags[PKIFailureInfoFlags["badRequest"] = 2] = "badRequest";
    PKIFailureInfoFlags[PKIFailureInfoFlags["badDataFormat"] = 16] = "badDataFormat";
    PKIFailureInfoFlags[PKIFailureInfoFlags["timeNotAvailable"] = 8192] = "timeNotAvailable";
    PKIFailureInfoFlags[PKIFailureInfoFlags["unacceptedPolicy"] = 16384] = "unacceptedPolicy";
    PKIFailureInfoFlags[PKIFailureInfoFlags["unacceptedExtension"] = 32768] = "unacceptedExtension";
    PKIFailureInfoFlags[PKIFailureInfoFlags["addInfoNotAvailable"] = 65536] = "addInfoNotAvailable";
    PKIFailureInfoFlags[PKIFailureInfoFlags["systemFailure"] = 16777216] = "systemFailure";
})(PKIFailureInfoFlags || (PKIFailureInfoFlags = {}));
export class PKIFailureInfo extends BitString {
    toJSON() {
        const flag = this.toNumber();
        const res = [];
        if (flag & PKIFailureInfoFlags.addInfoNotAvailable) {
            res.push("addInfoNotAvailable");
        }
        if (flag & PKIFailureInfoFlags.badAlg) {
            res.push("badAlg");
        }
        if (flag & PKIFailureInfoFlags.badDataFormat) {
            res.push("badDataFormat");
        }
        if (flag & PKIFailureInfoFlags.badRequest) {
            res.push("badRequest");
        }
        if (flag & PKIFailureInfoFlags.systemFailure) {
            res.push("systemFailure");
        }
        if (flag & PKIFailureInfoFlags.systemFailure) {
            res.push("systemFailure");
        }
        if (flag & PKIFailureInfoFlags.timeNotAvailable) {
            res.push("timeNotAvailable");
        }
        if (flag & PKIFailureInfoFlags.unacceptedExtension) {
            res.push("unacceptedExtension");
        }
        if (flag & PKIFailureInfoFlags.unacceptedPolicy) {
            res.push("unacceptedPolicy");
        }
        return res;
    }
    toString() {
        return `[${this.toJSON().join(", ")}]`;
    }
}
